import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from "@angular/forms"
import { DynamicFormValidatorMapperService } from "./dynamic-form-validator-mapper.service"
import { FormDefinition } from "../models/dynamic-form.interfaces"

@Injectable({
  providedIn: 'root',
})
export class DynamicFormBuilderService {
  constructor(
    private dynamicFormValidatorMapperService: DynamicFormValidatorMapperService,
    private formBuilder: UntypedFormBuilder) { }

  buildForm(formDefinition: FormDefinition) {
    const formGroup: UntypedFormGroup = {} as UntypedFormGroup;
    formDefinition.fields.forEach(field => {
        formGroup[field.key] = new UntypedFormControl({ value: field.value, disabled: field.disabled },
        this.dynamicFormValidatorMapperService.mapValidators(field.validation),
        this.dynamicFormValidatorMapperService.mapAsyncValidators(field.asyncValidation));
    });
    let form = this.formBuilder.group(formGroup);
    return form;
  }

}
